<template>
  <div class="resorts">
    <div class="title-button">
      <h1>Resorts</h1>

      <router-link to="/resorts/create" class="button p-3" v-if="userRole == 1">New resort</router-link>
    </div>

    <div class="box">
      <form @submit.stop.prevent="doSearch" class="box__header form--inline">
        <input v-model="quickSearch" type="search" placeholder="Quick search" />
        <button class="button button--small" type="submit">Search</button>
      </form>

      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="options"
        @edit="editResort"
        @delete="deleteResort"
      >
      </vdtnet-table>
    </div>
    <!-- box -->
  </div>
</template>

<script>
import "datatables.net";
import VdtnetTable from "vue-datatables-net";

export default {
  name: "resorts",
  components: {
    VdtnetTable
  },
  computed: {
    userRole() {
      return localStorage.getItem("user_role");
    }
  },
  data() {
    return {
      options: {
        ajax: {
          url: this.$api + "resorts/table",
          headers: {
            Accept: "application/json",
            Authorization: localStorage.getItem("token")
          }
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        dom: "rtlip",
        autoWidth: false,
        lengthMenu: [[25, 50, 100, 500, -1], [25, 50, 100, 500, "All"]],
        pageLength: 25
      },
      fields: {
        resort_name: { label: "Name" },
        location: { label: "Location" },
        edit: {
          sortable: false,
          label: " ",
          render: (data, type, row) => {
            return `<a href="/resort/edit/${ row.id }" data-action="edit" class="icon icon--more">Edit</a>`;
          }
        },
        // delete: {
        //   searchable: false,
        //   sortable: false,
        //   label: ' ',
        //   className: 'table-action',
        //   render: (data, type, row) => {
        //     return `<a href="/resorts/${ row.id }/delete" data-action="delete" class="icon icon--delete">Delete</a>`
        //   }
        // }
      },
      quickSearch: ""
    };
  },
  methods: {
    doSearch() {
      this.$refs.table.search(this.quickSearch);
    },
    editResort(data) {
      this.$router.push({ name: "resort-edit", params: { id: data.id } });
    },
    deleteResort(data) {
      this.$store.dispatch("setLoadStatus");
      fetch(this.$api + "resorts/" + data.id + "/delete", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: localStorage.getItem("token")
        }
      })
        .then(res => res.json())
        .then(response => {
          this.errors = response.errors;
          if (response.success == true) {
            this.$refs.table.reload();
            this.$notify({
              type: "success",
              title: response.message
            });
          } else if (response.errors) {
            this.$notify({
              type: "error",
              title: response.message
            });
          } else {
            this.$notify({
              type: "error",
              title: response.Error
            });
          }
          this.$store.dispatch("setLoadStatus");
        });
    }
  }
};
</script>
